module.exports = __webpack_public_path__ + "static/media/refocus.0be840ab.webp";